import { Component, OnInit } from '@angular/core';

import { Atividade } from '@app/core/models/perfil-profissiografico/atividade';
import { DetalharLaudoService } from '../services/detalhar-laudo.service';
import { PontosNivelAtividade } from '../../core/models/perfil-profissiografico/pontos-nivel-atividade';

@Component({
	selector: 'sgp-detalhar-laudo-candidato',
	templateUrl: './detalhar-laudo-candidato.component.html',
	styleUrls: ['./detalhar-laudo-candidato.component.scss']
})
export class DetalharLaudoCandidatoComponent implements OnInit {

	atividades: Atividade[] = [];
	constructor(protected detalharLaudoService: DetalharLaudoService) {}

	 ngOnInit(): void {
		this.detalharLaudoService.atividades$?.subscribe(dados => {
			if (dados) {
				this.atividades = dados.sort((a, b) => {
					const nomeA = a.nomeAtividade ?? "";
					const nomeB = b.nomeAtividade ?? "";
					return nomeA.localeCompare(nomeB);
				});
			}
		});
	} 
	getAtividadesComMaiorPontuacao(pontosNivelAtividade: PontosNivelAtividade[]): Atividade[] | null {
		if (!pontosNivelAtividade || pontosNivelAtividade.length === 0) {
			return null;
		}

		const maiorPontuacao = pontosNivelAtividade.reduce((prev, current) => {
    		const valor = current.valorPontuacao ?? 0;
    		return prev > valor ? prev : valor;
		}, pontosNivelAtividade[0]!.valorPontuacao!);

		// Filtra pelas atividades com maior pontuação
		let atividadesComMaiorPontuacao = this.filtraPontuacao(pontosNivelAtividade, maiorPontuacao);

		return atividadesComMaiorPontuacao;
	}

	getAtividadeTagClass(atividade: Atividade): string {
		if (atividade && atividade.idAtividade) {
			const index = this.atividades.findIndex(a => a.idAtividade === atividade.idAtividade);
			const colorIndex = (index !== -1 ? index : 0) % 8 + 1;
			return `atividade-tag-${colorIndex}`;
		}
		return 'atividade-tag-default';
	}

	private filtraPontuacao(pontosNivelAtividade: PontosNivelAtividade[], pontucao: number): Atividade[] | null {
		let atvs = pontosNivelAtividade
			.filter(ponto => ponto.valorPontuacao === pontucao)
			.map(ponto => this.atividades.find(a => a.idAtividade === ponto.idAtividade)!)
			.filter((atividade): atividade is Atividade => !!atividade);

		return atvs;
	}
	
}
